export const THEME = {
  LIGHT: 'light',
  DARK: 'dark',
  SYSTEM: 'system',
} as const;

export type ThemeType = typeof THEME.LIGHT | typeof THEME.DARK;

export const COLORS = {
  PRIMARY: {
    [THEME.LIGHT]: '#925f4b',
    [THEME.DARK]: '#f4c889',
  },
} as const;

export const IMAGE_HOSTNAME = {
  IMAGE_KIT: 'ik.imagekit.io',
  CLOUDINARY: 'res.cloudinary.com',
} as const;

export const STATIC_BLUR_DATA_URL =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4IDUiPjxmaWx0ZXIgaWQ9J2InIGNvbG9yLWludGVyYXBpc3Rpb24tZmlsdGVycydzUkNHIj48ZmVHYXVzc2lhbkJsdXJzdG9yIHN0ZERldml0aW9uPSIxIC8+PC9maWx0ZXI+PHJlY3QgcHJlc2VydmVBc3BlY3RSYXRoPSJub25lIiBmaWxsPSInN2I5ZmE2IiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB4PSIwIiB5PSIwIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1zdHJva2U9IjQyNjg3NCIvPjwvc3ZnPg==';

export const BREAKPOINTS = {
  MOBILE: 768,
  DESKTOP: 1280,
} as const;
